var map = {
	"./CloudFogSun.png": 72,
	"./CloudRain.png": 73,
	"./CloudSnow.png": 74,
	"./CloudWind.png": 75,
	"./Clouds.png": 76,
	"./DarkCloudRain.png": 77,
	"./DarkClouds.png": 78,
	"./Mist.png": 79,
	"./Moonrise.png": 80,
	"./Moonset.png": 81,
	"./Night.png": 82,
	"./NightCloudWind.png": 83,
	"./NightClouds.png": 84,
	"./NightFog.png": 85,
	"./NightRain.png": 86,
	"./NightWind.png": 87,
	"./Precipitation.png": 7,
	"./Rain2.png": 88,
	"./Snow.png": 89,
	"./SunCloudSnow.png": 90,
	"./SunCloudWindy.png": 91,
	"./SunClouds.png": 92,
	"./SunRain.png": 93,
	"./Sunny.png": 94,
	"./Sunrise.png": 8,
	"./Sunset.png": 9,
	"./Temperature.png": 95,
	"./Thunder.png": 96,
	"./Tornado.png": 97,
	"./Wind.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;